import React from 'react';

const ServiceDetail = ({ service, onClose, lang }) => {
  if (!service) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center px-4 py-4 sm:py-8 overflow-y-auto">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose}></div>

      {/* Modal Content */}
      <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl max-w-4xl w-full mx-auto my-4 sm:my-8 shadow-2xl border border-champagne/40 transform transition-all animate-fadeIn">
        {/* Close button */}
        <button
          className="absolute right-4 top-4 text-brown-600 hover:text-brown-800 transition-colors z-10"
          onClick={onClose}
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        <div className="p-4 sm:p-6 md:p-8">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            {/* Image Section - Left Top */}
            <div className="lg:w-1/2 flex items-start justify-center">
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full max-w-sm sm:max-w-md h-48 sm:h-64 md:h-80 object-cover rounded-xl shadow-soft border border-champagne/40"
                />
              </div>
            </div>
            
            {/* Content Section */}
            <div className="lg:w-1/2 space-y-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900 leading-tight">{service.title}</h2>
                <p className="text-gray-700 text-lg leading-relaxed">{service.description}</p>
              </div>
              
              {/* IV Sub-Services - Only show if subServices exist */}
              {service.subServices && service.subServices.length > 0 ? (
                <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-champagne/40">
                  <h3 className="text-lg font-semibold mb-4 text-[#2E6B4C]">Available IV Treatments</h3>
                  <div className="space-y-6">
                    {service.subServices.map((subService, index) => (
                      <div key={index} className="border-l-4 border-[#2E6B4C] pl-4 pb-4 last:pb-0">
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">{subService.name}</h4>
                        <p className="text-sm text-gray-600 mb-3 font-medium italic">{subService.ingredients}</p>
                        <ul className="space-y-2">
                          {subService.benefits.map((benefit, benefitIndex) => (
                            <li key={benefitIndex} className="flex items-start">
                              <svg className="w-4 h-4 text-[#2E6B4C] mr-2 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                              <span className="text-gray-700 text-sm leading-relaxed">{benefit}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  {/* Purpose */}
                  <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-champagne/40">
                    <h3 className="text-lg font-semibold mb-3 text-[#2E6B4C]">Purpose</h3>
                    <p className="text-gray-700 leading-relaxed">{service.purpose || service.description}</p>
                  </div>

                  {/* Mechanism */}
                  <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-champagne/40">
                    <h3 className="text-lg font-semibold mb-3 text-[#2E6B4C]">How it Works</h3>
                    <p className="text-gray-700 leading-relaxed">{service.mechanism || 'Treatment mechanism information will be provided during consultation.'}</p>
                  </div>

                  {/* Duration */}
                  <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-champagne/40">
                    <h3 className="text-lg font-semibold mb-3 text-[#2E6B4C]">Duration & Results</h3>
                    <p className="text-gray-700 leading-relaxed">{service.duration || 'Treatment duration varies by individual needs.'}</p>
                  </div>

                  {/* Features/Benefits */}
                  <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-champagne/40">
                    <h3 className="text-lg font-semibold mb-3 text-[#2E6B4C]">Key Benefits</h3>
                    <ul className="space-y-3">
                      {service.features && service.features.map((feature, index) => (
                        <li key={index} className="flex items-start">
                          <svg className="w-5 h-5 text-[#2E6B4C] mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          <span className="text-gray-700 leading-relaxed">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;